import React, { useEffect, useRef, useState } from "react";
import DiwaliHeader from "./DiwaliHeader";
import "./diwali.css";

const ASSET_BASE = "/diwaliEscapeRoom";

// glowstone-old/thankyou.php equivalent: background fades in, the intro
// text types itself out character by character, then a "Continue" button
// appears revealing the closing popup/Thankyou-8.png card.
const INTRO_TEXT =
  "Congratulations, brave souls! You've not only found the glowstone but also rediscovered the true essence of Diwali. It's not just about the lights and festivities but the journey, the challenges faced, and the triumph of light over darkness, of good over evil.";

export default function DiwaliThankyou() {
  const [bgVisible, setBgVisible] = useState(false);
  const [typedText, setTypedText] = useState("");
  const [showContinue, setShowContinue] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [isPortrait, setIsPortrait] = useState(
    () => window.innerHeight > window.innerWidth
  );
  const charIndexRef = useRef(0);

  useEffect(() => {
    const check = () => setIsPortrait(window.innerHeight > window.innerWidth);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  useEffect(() => {
    const fadeTimer = setTimeout(() => setBgVisible(true), 50);
    return () => clearTimeout(fadeTimer);
  }, []);

  useEffect(() => {
    // Matches legacy: background fade (2s) finishes, then typing starts.
    const startTimer = setTimeout(() => {
      const interval = setInterval(() => {
        charIndexRef.current += 1;
        setTypedText(INTRO_TEXT.slice(0, charIndexRef.current));
        if (charIndexRef.current >= INTRO_TEXT.length) {
          clearInterval(interval);
          setShowContinue(true);
        }
      }, 30);
      return () => clearInterval(interval);
    }, 2000);
    return () => clearTimeout(startTimer);
  }, []);

  return (
    <div className="dw-thankyou-root">
      <DiwaliHeader />
      <div
        className="dw-thankyou-bg"
        style={{
          backgroundImage: `url(${ASSET_BASE}/images/${
            isPortrait ? "thankyou_main.jpg" : "thankyou.jpg"
          })`,
          opacity: bgVisible ? 1 : 0,
        }}
      />

      <div className="dw-thankyou-content">
        <div className="dw-thankyou-text">{typedText}</div>
        {showContinue && (
          <div
            className="dw-thankyou-continue"
            onClick={() => setPopupOpen(true)}
          >
            Continue
          </div>
        )}
      </div>

      {popupOpen && (
        <div className="dw-popup-overlay">
          <div className="dw-popup-panel dw-thankyou-popup-panel">
            <img
              src={`${ASSET_BASE}/popup/Thankyou-8.png`}
              alt=""
              className="dw-popup-image"
            />
          </div>
        </div>
      )}
    </div>
  );
}
